<template>
  <v-flex class="home mt-4" data-qa="home-flex-6y1fye">
    <Loader v-if="loaderEnabled"/>
    <v-layout v-if="ifDataAvailable()" row wrap data-qa="home-layout-x2o4so">
      <v-flex xs12 sm10 md10 lg10 xl10 data-qa="home-flex-s9b4ut">
        <div class="ma-1" v-if="showCustomerSupportInfo" data-qa="home-div-st6taq">
          <v-alert
            icon="mdi-information-outline" 
            class="v-alert--info"
           data-qa="home-alert-z53261t">
            <span class="body-2 font-weight-regular" data-qa="home-span-vmeb9e">{{ $t('common.customerSupportInfo') }}</span>
          </v-alert>
        </div>
        <HomeAccountDetails/>
      </v-flex>
    </v-layout>
    <!-- Cookie -->
    <cookie-law theme="blood-orange" class="pt-1 pb-1" :buttonText="$t('common.okay')">
      <div slot="message" data-qa="home-div-v1p6bi">
        {{ $t("common.cookiePolicyAppName") }} {{ $t("common.cookiePolicy") }}
        <span
          class="dashboard__underlined-cursor-pointer"
          data-qa="home-span-tek9ar"
        >
          <a target="_blank" :href="$appSettings.applicationSettings.privacyAndCookiePolicy">{{ $t("common.privacyPolicy") }}</a>
        </span>
      </div>
    </cookie-law>
  </v-flex>
</template>

<script>
import '@/styles/pages/home/home.scss'
import CookieLaw from 'vue-cookie-law'
import preload from '@/util/preload'
import store from '@/core/store'
import event from '@/util/event'
import Loader from '../../components/common/Loader.vue'

export default {
  name: 'Home',
  components: {
    Loader,
    CookieLaw,
    HomeAccountDetails: () => import('@/views/home/HomeAccountDetails.vue')
  },
  data () {
    return {
      loaderEnabled: false,
      showCustomerSupportInfo: this.$appSettings.defaultConfigurations.showCustomerSupportInfo
    }
  },
  methods: {
    ifDataAvailable () {
      return store.getters['userStore/userData'].myAccounts
    },
    get: (k) => JSON.parse(sessionStorage.getItem(k)),
    fetchAccounts () {
      this.loaderEnabled = true
      const { get } = this
      // const isSmeLogin = get('isSmeLogin') || false
      // const customerCode = get('customerCode') || ''
      const username = get('username') || ''

      preload.getListOfAccounts(username)
      // preload.getCustomerDetails(isSmeLogin ? customerCode : username)
      preload.getListOfLoanAccounts(username)
    }
  },
  mounted () {
    event.$on('set_myAccounts', () => {
      this.loaderEnabled = false
    })
    if (!this.ifDataAvailable()) {
      this.fetchAccounts()
    }
  }
}
</script>
